import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { playCaptchaAudio } from "../utils/playCaptchaAudio";
import { drawCaptchaToCanvas, generateRandomText } from "../utils/drawCaptchaToCanvas";
let captchaCode = "";

interface CaptchaComponentProps {
  onVerify: () => void;
}

const CaptchaComponent: React.FC<CaptchaComponentProps> = ({ onVerify }) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const [captchaInput, setCaptchaInput] = useState("");

  useEffect(() => {
    generateCaptcha();
  }, []);

  const generateCaptcha = () => {
    captchaCode = generateRandomText();
    if (canvasRef.current) {
      drawCaptchaToCanvas(canvasRef.current, captchaCode);
    }
  };

  const refreshCaptcha = () => {
    playCaptchaAudio("");
    generateCaptcha();
    setCaptchaInput("");
  };

  const handleSubmit = () => {
    if (!captchaInput) {
      toast.error("Please type the CAPTCHA provided!", { position: "top-right", autoClose: 3000 });
      return;
    }
    if (captchaInput !== captchaCode) {
      toast.error("Wrong CAPTCHA answer! Please try again!", { position: "top-right", autoClose: 3000 });
      refreshCaptcha();
      return;
    }
    toast.success("CAPTCHA verified successfully.", { position: "top-right", autoClose: 3000 });
    onVerify();
  };

  const handleEnterPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") handleSubmit();
  };

  return (
    <div className="loader-container-captcha">
      <div id="captcha-widget">
        <div className="captcha-header">
          <span className="captchaHeaderText">Please solve the captcha to continue</span>
        </div>
        <div id="captcha-padding">
          <div id="captcha-input" style={{ textAlign: "center" }}>
            <div id="captcha-image">
              <canvas ref={canvasRef} style={{ border: "1px solid #ccc" }} />
            </div>
            <div id="captcha-help">
              <button onClick={refreshCaptcha}>↻</button>
              <button
                id="speaker-button"
                className="speaker-button"
                onClick={() => playCaptchaAudio(captchaCode)}
              >
                ►
              </button>
            </div>
            <input
              type="text"
              placeholder="Enter The Captcha"
              value={captchaInput}
              onChange={(e) => setCaptchaInput(e.target.value)}
              style={{ textAlign: "center" }}
              required
              onKeyDown={handleEnterPress}
            />
          </div>
          <div id="captcha-submit">
            <button type="button" onClick={handleSubmit}>Submit</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CaptchaComponent;
